module.exports = __webpack_public_path__ + "static/media/09.8f550273.jpg";